(function () {
    const STORAGE_KEY = 'essence_account_registration_tracked';
    const REDIRECT_DELAY_MS = 400;
    const PROVIDER_POLL_INTERVAL_MS = 2000;
    const PROVIDER_MAX_RETRIES = 10;

    const DEBUG_PARAM = 'debug_track_registration';
    const tiktokPixelId = document.currentScript && document.currentScript.dataset.tiktokPixelId;

    function hasDebugParam() {
        try {
            return new URLSearchParams(window.location.search).has(DEBUG_PARAM);
        } catch (e) {
            return false;
        }
    }

    function loadTikTokPixel(pixelId) {
        !(function (w, t) {
            w.TiktokAnalyticsObject = t;
            var ttq = (w[t] = w[t] || []);
            ttq.methods = ['page', 'track', 'identify', 'instances', 'debug', 'on', 'off', 'once', 'ready', 'alias', 'group', 'enableCookie', 'disableCookie', 'holdConsent', 'revokeConsent', 'grantConsent'];
            ttq.setAndDefer = function (t, e) {
                t[e] = function () {
                    t.push([e].concat(Array.prototype.slice.call(arguments, 0)));
                };
            };
            for (var i = 0; i < ttq.methods.length; i++) ttq.setAndDefer(ttq, ttq.methods[i]);
            ttq.instance = function (t) {
                for (var e = ttq._i[t] || [], n = 0; n < ttq.methods.length; n++) ttq.setAndDefer(e, ttq.methods[n]);
                return e;
            };
            ttq.load = function (e, n) {
                var r = 'https://analytics.tiktok.com/i18n/pixel/events.js';
                ttq._i = ttq._i || {};
                ttq._i[e] = [];
                ttq._i[e]._u = r;
                ttq._t = ttq._t || {};
                ttq._t[e] = +new Date();
                ttq._o = ttq._o || {};
                ttq._o[e] = n || {};
                var o = document.createElement('script');
                o.type = 'text/javascript';
                o.async = !0;
                o.src = r + '?sdkid=' + e + '&lib=' + t;
                var a = document.getElementsByTagName('script')[0];
                a.parentNode.insertBefore(o, a);
            };
            ttq.load(pixelId);
            ttq.page();
        })(window, 'ttq');
    }

    function hasMarketingConsent() {
        try {
            const consent = window.Shopify && window.Shopify.customerPrivacy && window.Shopify.customerPrivacy.currentVisitorConsent();
            return !!consent && consent.marketing === 'yes';
        } catch (e) {
            return false;
        }
    }

    if (tiktokPixelId) {
        let pixelLoaded = false;
        const tryLoad = () => {
            if (pixelLoaded) return;
            if (hasMarketingConsent() || hasDebugParam()) {
                pixelLoaded = true;
                console.log('[tracking] loading TikTok pixel');
                loadTikTokPixel(tiktokPixelId);
            }
        };

        if (hasDebugParam()) {
            tryLoad();
        }

        const pollId = setInterval(() => {
            if (window.Shopify && window.Shopify.customerPrivacy) {
                clearInterval(pollId);
                tryLoad();
                document.addEventListener('visitorConsentCollected', tryLoad);
            }
        }, 500);
    }

    function safeCall(fn) {
        try {
            fn();
        } catch (e) {
            console.warn('[tracking]', e);
        }
    }

    function waitFor(name, check) {
        return new Promise((resolve) => {
            if (check()) return resolve(true);
            let attempts = 0;
            const id = setInterval(() => {
                attempts += 1;
                if (check()) {
                    console.log('[tracking]', name, 'available after', attempts, 'retries');
                    clearInterval(id);
                    resolve(true);
                } else if (attempts >= PROVIDER_MAX_RETRIES) {
                    clearInterval(id);
                    resolve(false);
                } else {
                    console.log('[tracking]', name, 'not ready, retry', attempts, '/', PROVIDER_MAX_RETRIES);
                }
            }, PROVIDER_POLL_INTERVAL_MS);
        });
    }

    async function trackAccountRegistration() {
        const debug = hasDebugParam();
        console.log('[tracking] trackAccountRegistration called', debug ? '(debug mode)' : '');
        if (!debug && !hasMarketingConsent()) {
            console.warn('[tracking] marketing consent not granted, skipping registration tracking');
            return;
        }
        if (!debug) {
            try {
                if (localStorage.getItem(STORAGE_KEY)) {
                    console.log('[tracking] already tracked, skipping');
                    return;
                }
                localStorage.setItem(STORAGE_KEY, new Date().getTime().toString());
            } catch (e) {
                console.warn('[tracking] localStorage unavailable, firing without dedupe', e);
            }
        }

        const [fbqReady, gtagReady, ttqReady] = await Promise.all([
            waitFor('fbq', () => typeof window.fbq === 'function'),
            waitFor('gtag', () => typeof window.gtag === 'function'),
            waitFor('ttq', () => window.ttq && typeof window.ttq.track === 'function'),
        ]);

        if (fbqReady) {
            console.log('[tracking] firing fbq CompleteRegistration');
            safeCall(() => window.fbq('track', 'CompleteRegistration'));
        } else {
            console.warn('[tracking] fbq not available after wait');
        }

        const gaPromise = new Promise((resolve) => {
            if (gtagReady) {
                console.log('[tracking] firing gtag sign_up');
                let resolved = false;
                const done = () => {
                    if (!resolved) {
                        resolved = true;
                        resolve();
                    }
                };
                safeCall(() =>
                    window.gtag('event', 'sign_up', {
                        method: 'referral',
                        event_callback: done,
                    }),
                );
                setTimeout(done, REDIRECT_DELAY_MS);
            } else {
                console.warn('[tracking] gtag not available after wait');
                resolve();
            }
        });

        if (ttqReady) {
            console.log('[tracking] firing ttq CompleteRegistration');
            safeCall(() => window.ttq.track('CompleteRegistration'));
        } else {
            console.warn('[tracking] ttq not available after wait');
        }

        await gaPromise;
        console.log('[tracking] trackAccountRegistration complete');
    }

    window.essenceTracking = { trackAccountRegistration };

    if (hasDebugParam()) {
        console.log('[tracking] debug param detected, auto-invoking trackAccountRegistration');
        if (document.readyState === 'loading') {
            document.addEventListener('DOMContentLoaded', trackAccountRegistration);
        } else {
            trackAccountRegistration();
        }
    }
})();
